/**
 * Speed test audit API - fetch events for monitoring tab
 * Backend: GET /maiApi/speed-test/audit
 */

const getApiBase = () =>
  process.env.REACT_APP_API_SERVER_URL || 'http://10.153.28.40:8080';

/**
 * @param {Object} params
 * @param {number} [params.minutes=240] - Time window (minutes)
 * @param {number} [params.limit=200] - Max rows
 * @param {string} [params.event_type] - Filter by event_type (rejected, token_issued, results_received, etc.)
 * @param {string} [params.android_id] - Filter by android_id
 * @param {string} [params.friendly_name] - Filter by device friendly name (substring match)
 * @returns {Promise<{ rows: Array, summary: Object }>}
 */
export async function fetchSpeedTestAudit(params = {}) {
  const { minutes = 240, limit = 200, event_type, android_id, friendly_name, signal } = params;
  const search = new URLSearchParams();
  search.set('minutes', String(minutes));
  search.set('limit', String(limit));
  if (event_type) search.set('event_type', event_type);
  if (android_id) search.set('android_id', android_id.trim());
  if (friendly_name) search.set('friendly_name', friendly_name.trim());

  const url = `${getApiBase()}/maiApi/speed-test/audit?${search.toString()}`;
  const res = await fetch(url, { signal });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ message: res.statusText }));
    throw new Error(err.message || err.error || 'Failed to fetch audit');
  }
  return res.json();
}

export default { fetchSpeedTestAudit };
